import { RoutesDescriptions } from '../types/RoutesDescriptions';
import { RoutePath } from '../enums/RoutePath';

export class RouteService {
  static getRoutePathsFromDescriptions(routesDescriptions: RoutesDescriptions): RoutePath[] {
    return Object.keys(routesDescriptions).filter((key: string) => !!routesDescriptions[key]) as RoutePath[];
  }
}
